"use client";

import React from "react";
import { Network, Users, Map } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
const tabsData = [{
  id: "hierarki",
  label: "Hierarki Nasional",
  icon: Network
}, {
  id: "struktur",
  label: "Struktur MPN",
  icon: Users
}, {
  id: "direktori",
  label: "Direktori Struktur Wilayah",
  icon: Map
}];
export default function ViewSwitcherTabs() {
  return <section id="viewswitchertabs" className="w-full bg-background pt-6 pb-2">
      <div className="container mx-auto px-4 md:px-6">
        <Tabs defaultValue="hierarki" className="w-full">
          <ScrollArea className="w-full">
            <TabsList className="flex w-full justify-start md:justify-center bg-transparent p-0 h-auto border-b border-border">
              {tabsData.map((tab, i) => {
              const Icon = tab.icon;
              return <TabsTrigger key={tab.id} value={tab.id} data-index={i} className="relative border-b-2 border-transparent px-4 py-3 md:px-8 md:py-4 text-sm md:text-base font-semibold text-muted-foreground hover:text-foreground data-[state=active]:border-primary data-[state=active]:text-primary data-[state=active]:bg-background transition-all">
                    <Icon className="mr-2 h-5 w-5" />
                    {tab.label}
                  </TabsTrigger>;
            })}
            </TabsList>
            <ScrollBar orientation="horizontal" className="invisible" />
          </ScrollArea>

          {}
          <div className="mt-8">
            {tabsData.map((tab, i) => <TabsContent key={tab.id} value={tab.id} data-index={i} className="animate-in fade-in-50 duration-500">
                <div className="flex flex-col items-center justify-center p-12 border border-dashed border-border rounded-lg bg-muted/30">
                  <IconComponent icon={tab.icon} className="h-12 w-12 text-muted-foreground/50 mb-4" />
                  <p className="text-muted-foreground font-medium text-center">
                    Tampilan data untuk <span className="text-foreground font-semibold">{tab.label}</span> akan dimuat di sini.
                  </p>
                </div>
              </TabsContent>)}
          </div>
        </Tabs>
      </div>
    </section>;
}
function IconComponent({
  icon: Icon,
  className
}: {
  icon: React.ElementType;
  className?: string;
}) {
  return <Icon className={className} />;
}